<template>
  <div class="bg-white p-4 rounded shadow-ls">
    <!-- Mensagem de sucesso caso a api retorne 200 -->
    <success
      :control="controlSuccess"
      :msg="
        '<strong>Recebemos sua mensagem!</strong><br>Entraremos em contato em breve.'
      "
      data-aos="fade-in-zoom"
      data-aos-once="true"
    />

    <!-- Mensagem em caso de erro na api -->
    <error
      :control="controlError"
      :msg="'Erro na solicitação. Por favor, tente novamente.'"
      data-aos="fade-in-zoom"
      data-aos-once="true"
    />

    <form class="auto-trader">
      <div v-if="step === 1">
        <step-1
          :nome.sync="nome"
          :cpf.sync="cpf"
          :rg.sync="rg"
          :birthdate.sync="birthdate"
          :email.sync="email"
          :celular.sync="celular"
        />
        <strong class="text-danger" v-if="invalidForm">Todos os campos são obrigatórios</strong>
        <div class="footer-buttons">
          <button
            @click.prevent="validateStep1()"
            class="btn text-white button-next btn-purple"
          >Próximo</button>
        </div>
      </div>

      <div v-if="step === 2">
        <step-2
          :cep.sync="cep"
          :address.sync="address"
          :number.sync="number"
          :neighborhood.sync="neighborhood"
          :complement.sync="complement"
          :city.sync="city"
          :uf.sync="uf"
        />

        <div v-if="invalidForm" class="invalid-form">
          <strong class="text-danger">Preencha os campos obrigatórios</strong>
        </div>
        <div class="footer-buttons">
          <button @click.prevent="prev()" class="btn text-white btn-purple">Anterior</button>
          <button
            @click.prevent="validateStep2()"
            class="btn text-white button-next btn-purple"
          >Próximo</button>
        </div>
      </div>

      <div v-if="step === 3">
        <step-3
          :ocupacaoCheck.sync="ocupacaoCheck"
          :ocupacao.sync="ocupacao"
          :negocioProprioCheck.sync="negocioProprioCheck"
          :negocioProprio.sync="negocioProprio"
          :tipoProdutoCheck.sync="tipoProdutoCheck"
          :tipoProduto.sync="tipoProduto"
          :experienciaCheck.sync="experienciaCheck"
          :experiencia.sync="experiencia"
          :experienciaSegmentoCheck.sync="experienciaSegmentoCheck"
          :experienciaSegmento.sync="experienciaSegmento"
        />
        <label>Qual o perfil profissional se encaixa mais com você?</label>
        <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
          <label>
            <input type="checkbox" v-on:click="updateArrProfessionalProfile('Administrativo')" />
            <i class="helper" style="top: 3px;"></i>Administrativo
          </label>
          <label>
            <input
              type="checkbox"
              v-on:click="updateArrProfessionalProfile('Financeiro / Contábil')"
            />
            <i class="helper" style="top: 3px;"></i>Financeiro / Contábil
          </label>
          <label>
            <input type="checkbox" v-on:click="updateArrProfessionalProfile('Comercial / Vendas')" />
            <i class="helper" style="top: 3px;"></i>Comercial / Vendas
          </label>
          <label>
            <input type="checkbox" v-on:click="updateArrProfessionalProfile('Operacional')" />
            <i class="helper" style="top: 3px;"></i>Operacional
          </label>
          <label>
            <input
              type="checkbox"
              v-on:click="
                updateArrProfessionalProfile('TI, Desenvolvimento de Sistemas')
              "
            />
            <i class="helper" style="top: 3px;"></i>TI, Desenvolvimento de
            Sistemas
          </label>
        </div>

        <div v-if="invalidForm" class="invalid-form">
          <strong class="text-danger">Selecione ao menos um perfil profissional</strong>
        </div>
        <div class="footer-buttons">
          <button @click.prevent="prev()" class="btn text-white btn-purple">Anterior</button>
          <button
            @click.prevent="validateStep3()"
            class="btn text-white button-next btn-purple"
          >Próximo</button>
        </div>
      </div>

      <div v-if="step === 4">
        <step-4
          :possuiVeiculo.sync="possuiVeiculo"
          :capitalParaInvestimento.sync="capitalParaInvestimento"
          :capitalInvestimento.sync="capitalInvestimento"
        />

        <label>Qual sua renda mensal?</label>
        <b-form-group class="w-100 mt-0">
          <money v-model="rendaMensal" v-bind="money"></money>
          <i class="bar"></i>
        </b-form-group>

        <label>Qual valor mensal espera receber?</label>
        <div class="checkbox mt-0 mb-4 d-flex flex-column justify-content-center">
          <label>
            <input type="radio" v-model="valorEsperado" :value="'R$ 4.500 a R$ 6.000'" />
            <i class="helper" style="top: 3px;"></i>R$ 4.500 a R$ 6.000
          </label>
          <label>
            <input type="radio" v-model="valorEsperado" :value="'R$ 6.000 a R$ 10.000'" />
            <i class="helper" style="top: 3px;"></i>R$ 6.000 a R$ 10.000
          </label>
          <label>
            <input type="radio" v-model="valorEsperado" :value="'R$ 10.000 a R$ 15.000'" />
            <i class="helper" style="top: 3px;"></i>R$ 10.000 a R$ 15.000
          </label>
          <label>
            <input type="radio" v-model="valorEsperado" :value="'Acima de R$ 15.000'" />
            <i class="helper" style="top: 3px;"></i>Acima de R$ 15.000
          </label>
        </div>

        <div v-if="invalidForm" class="invalid-form">
          <strong class="text-danger">Preencha os campos obrigatórios</strong>
        </div>

        <div class="footer-buttons">
          <button @click.prevent="prev()" class="btn text-white btn-purple">Anterior</button>
          <button
            @click.prevent="validateStep4()"
            class="btn text-white button-next btn-purple"
          >Próximo</button>
        </div>
      </div>

      <div v-if="step === 5">
        <step-5
          :desejaLibFinanceira.sync="desejaLibFinanceira"
          :sentimentoTrabalho.sync="sentimentoTrabalho"
          :gostaDeCarros.sync="gostaDeCarros"
          :pediuOpiniao.sync="pediuOpiniao"
          :conheceProprietario.sync="conheceProprietario"
          :suaExpectativa.sync="suaExpectativa"
        />

        <div v-if="invalidForm" class="invalid-form">
          <strong class="text-danger">Preencha os campos obrigatórios</strong>
        </div>

        <div class="footer-buttons">
          <button
            :disabled="stateSubmit"
            @click.prevent="prev()"
            class="btn text-white btn-purple"
          >Anterior</button>
          <button
            v-html="textSubmit"
            :disabled="stateSubmit"
            @click.prevent="validateStep5()"
            class="btn text-white button-next btn-purple"
          >Enviar</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";

import Success from "@/components/Success.vue";
import Error from "@/components/Error.vue";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";

import { VueMaskDirective } from "v-mask";

import axios from "axios";

import AOS from "aos";
import "aos/dist/aos.css";

AOS.init();

export default {
  directives: {
    mask: VueMaskDirective
  },
  components: {
    Success,
    Error,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5
  },
  data: () => {
    return {
      textSubmit: "Enviar",
      stateSubmit: false,
      ocupacaoCheck: false,
      negocioProprioCheck: false,
      tipoProdutoCheck: false,
      experienciaCheck: false,
      experienciaSegmentoCheck: false,
      invalidForm: false,
      controlSuccess: false,
      controlError: false,
      possuiVeiculo: "",
      capitalParaInvestimento: "",
      desejaLibFinanceira: "",
      nome: "",
      cpf: "",
      rg: "",
      birthdate: "",
      email: "",
      celular: "",
      cep: "",
      address: "",
      number: "",
      neighborhood: "",
      complement: "",
      city: "",
      uf: "",
      ocupacao: "",
      negocioProprio: "",
      tipoProduto: "",
      experiencia: "",
      experienciaSegmento: "",
      capitalInvestimento: "",
      rendaMensal: "",
      valorEsperado: "",
      sentimentoTrabalho: "",
      gostaDeCarros: "",
      pediuOpiniao: "",
      conheceProprietario: "",
      suaExpectativa: "",
      perfilProfissional: [],
      step: 1,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    ...mapState(["EMAIL_API"])
  },
  methods: {
    showInvalidForm() {
      this.invalidForm = true;
      setTimeout(() => {
        this.invalidForm = false;
      }, 4000);
    },
    convertToDate(date) {
      var dt = date.split("-");
      return `${dt[2]}/${dt[1]}/${dt[0]}`;
    },
    numberToReal(numero) {
      var numero = numero.toFixed(2).split(".");
      numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join(".");
      return numero.join(",");
    },
    removeA(arr) {
      var what,
        a = arguments,
        L = a.length,
        ax;
      while (L > 1 && arr.length) {
        what = a[--L];
        while ((ax = arr.indexOf(what)) !== -1) {
          arr.splice(ax, 1);
        }
      }
      return arr;
    },
    updateArrProfessionalProfile(perfil) {
      if (this.perfilProfissional.includes(perfil)) {
        this.removeA(this.perfilProfissional, perfil);
      } else {
        this.perfilProfissional.push(perfil);
      }
    },
    async sendLead() {
      // Mudando o estado do botão de submit
      this.textSubmit =
        '<div class="spinner-border spinner-border-sm text-light mr-2" role="status"><span class="sr-only">Loading...</span></div>enviando...';
      this.stateSubmit = true;

      let self = this;
      await axios
        .post(`${self.EMAIL_API.API_URL}/mail`, {
          headers: {
            "Content-Type": "application/json"
          },
          params: {
            to: self.EMAIL_API.TO,
            title: "Vaapty - Rota do Trader",
            data: [
              {
                legend: "Nome",
                desc: self.nome
              },
              {
                legend: "CPF",
                desc: self.cpf
              },
              {
                legend: "RG",
                desc: self.rg
              },
              {
                legend: "Data de nascimento",
                desc: this.convertToDate(self.birthdate)
              },
              {
                legend: "E-mail",
                desc: self.email
              },
              {
                legend: "Celular",
                desc: self.celular
              },
              {
                legend: "CEP",
                desc: self.cep
              },
              {
                legend: "Endereço",
                desc: self.address
              },
              {
                legend: "Número",
                desc: self.number
              },
              {
                legend: "Bairro",
                desc: self.neighborhood
              },
              {
                legend: "Complemento",
                desc: self.complement
              },
              {
                legend: "Cidade",
                desc: self.city
              },
              {
                legend: "Estado",
                desc: self.uf
              },
              {
                legend: "Você trabalha atualmente?",
                desc: self.ocupacaoCheck ? `Sim. ${self.ocupacao}` : "Não"
              },
              {
                legend: "Você possui ou já possuiu um negócio próprio?",
                desc: self.negocioProprioCheck
                  ? `Sim. ${self.negocioProprio}`
                  : "Não"
              },
              {
                legend: "Você já trabalhou com vendas?",
                desc: self.tipoProdutoCheck ? `Sim. ${self.tipoProduto}` : "Não"
              },
              {
                legend: "Você tem experiência com Gestão de Equipes / Pessoas?",
                desc: self.experienciaCheck ? `Sim. ${self.experiencia}` : "Não"
              },
              {
                legend: "Voce tem experiência no Segmento automotivo?",
                desc: self.experienciaSegmentoCheck
                  ? `Sim. ${self.experienciaSegmento}`
                  : "Não"
              },
              {
                legend: "Qual o perfil profissional se encaixa mais com você?",
                desc: self.perfilProfissional.join(", ")
              },
              {
                legend: "Você possui veículo?",
                desc: self.possuiVeiculo
              },
              {
                legend:
                  "Você tem disponibilidade de capital para investimento?",
                desc:
                  self.capitalParaInvestimento !== "Não, outros"
                    ? self.capitalParaInvestimento
                    : `${self.capitalParaInvestimento}. ${self.capitalInvestimento}`
              },
              {
                legend: "Qual sua renda mensal?",
                desc: this.numberToReal(self.rendaMensal)
              },
              {
                legend: "Qual valor mensal espera receber?",
                desc: self.valorEsperado
              },
              {
                legend:
                  "Você deseja ter liberdade financeira e ser dono do seu próprio negócio?",
                desc: self.desejaLibFinanceira
              },
              {
                legend:
                  "Como você se sente em relação ao seu trabalho atual ou anterior, levando em consideração seu empenho e remuneração?",
                desc: self.sentimentoTrabalho
              },
              {
                legend: "Você gosta de carros?",
                desc: self.gostaDeCarros
              },
              {
                legend:
                  "Algum amigo ou conhecido já pediu sua opinião sobre algum modelo de veículo que fosse comprar?",
                desc: self.pediuOpiniao
              },
              {
                legend:
                  "Você conhece algum proprietário de loja de veículos e qual o padrão de vida dele?",
                desc: self.conheceProprietario
              },
              {
                legend:
                  "Qual a sua expectativa para adquirir sua licença Vaapty Auto Traders?",
                desc: self.suaExpectativa
              }
            ],
            host_body: {
              Name: self.EMAIL_API.HOST_NAME,
              Port: self.EMAIL_API.PORT,
              User: self.EMAIL_API.USER,
              Pass: self.EMAIL_API.PASS
            }
          }
        })
        .then(() => {
          // Habilitando mensagem de sucesso
          self.controlSuccess = true;

          setTimeout(() => {
            this.$router.push("obrigado-trader");
            self.controlSuccess = false;
          }, 3000);

          // Zerando o estado dos inputs
          self.ocupacaoCheck = false;
          self.negocioProprioCheck = false;
          self.tipoProdutoCheck = false;
          self.experienciaCheck = false;
          self.experienciaSegmentoCheck = false;
          self.invalidForm = false;
          self.possuiVeiculo = "";
          self.capitalParaInvestimento = "";
          self.desejaLibFinanceira = "";
          self.nome = "";
          self.cpf = "";
          self.rg = "";
          self.birthdate = "";
          self.email = "";
          self.celular = "";
          self.cep = "";
          self.address = "";
          self.number = "";
          self.neighborhood = "";
          self.complement = "";
          self.city = "";
          self.uf = "";
          self.ocupacao = "";
          self.negocioProprio = "";
          self.tipoProduto = "";
          self.experiencia = "";
          self.experienciaSegmento = "";
          self.capitalInvestimento = "";
          self.rendaMensal = "";
          self.valorEsperado = "";
          self.sentimentoTrabalho = "";
          self.gostaDeCarros = "";
          self.pediuOpiniao = "";
          self.conheceProprietario = "";
          self.suaExpectativa = "";
          self.perfilProfissional = [];
          self.step = 1;
        })
        .catch(err => {
          this.controlError = true;
          setTimeout(() => {
            self.controlError = false;
          }, 4000);
        });

      // Retornando ao estado original do botão pós envio de formulário
      this.textSubmit = "Enviar";
      this.stateSubmit = false;
    },
    validateStep1() {
      if (
        this.nome !== "" &&
        this.cpf !== "" &&
        this.rg !== "" &&
        this.birthdate !== "" &&
        this.email !== "" &&
        this.celular !== ""
      ) {
        this.step++;
      } else {
        this.showInvalidForm();
      }
    },
    validateStep2() {
      if (
        this.cep !== "" &&
        this.address !== "" &&
        this.number !== "" &&
        this.neighborhood !== "" &&
        this.city !== "" &&
        this.uf !== ""
      ) {
        this.step++;
      } else {
        this.showInvalidForm();
      }
    },
    validateStep3() {
      if (
        this.perfilProfissional.length === 0 ||
        (this.ocupacaoCheck && this.ocupacao === "") ||
        (this.negocioProprioCheck && this.negocioProprio === "") ||
        (this.tipoProdutoCheck && this.tipoProduto === "") ||
        (this.experienciaCheck && this.experiencia === "") ||
        (this.experienciaSegmentoCheck && this.experienciaSegmento === "")
      ) {
        this.showInvalidForm();
      } else {
        this.step++;
      }
    },
    validateStep4() {
      if (
        this.possuiVeiculo !== "" &&
        this.capitalParaInvestimento !== "" &&
        this.rendaMensal !== "" &&
        this.valorEsperado !== ""
      ) {
        this.step++;
      } else {
        this.showInvalidForm();
      }
    },
    validateStep5() {
      if (
        this.desejaLibFinanceira !== "" &&
        this.sentimentoTrabalho !== "" &&
        this.gostaDeCarros !== "" &&
        this.pediuOpiniao !== "" &&
        this.conheceProprietario !== "" &&
        this.suaExpectativa !== ""
      ) {
        this.sendLead();
      } else {
        this.showInvalidForm();
      }
    },
    prev() {
      this.invalidForm = false;
      this.step--;
    },
    next() {
      this.step++;
    }
  }
};
</script>

<style lang="scss" scoped>
form {
  &.auto-trader {
    .button-next {
      float: right;
    }
    h5 {
      margin-bottom: 30px;
    }

    .footer-buttons {
      float: left;
      width: 100%;
      @media screen and (max-width: 767px) {
        margin-bottom: 30px;
      }
    }
  }

  .invalid-form {
    margin-top: -15px;
    margin-bottom: 15px;
  }
}

.container-site:first-child {
  width: 100vw !important;
}
</style>
